import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "modal",
    tabindex: "-1",
    role: "dialog",
    id: "modal-confirmacao-campanha",
    "data-backdrop": "static",
    "data-keyboard": "false"
};
const _hoisted_2 = {
    class: "modal-dialog",
    style: { "min-width": "30%" }
};
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = { class: "modal-body" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-spinner fa-spin fa-1x fa-fw" }, null, -1);
const _hoisted_7 = { key: 1 };
const _hoisted_8 = ["href"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { "aria-hidden": "true" }, "×", -1);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "text-center font-weight-bold" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "text-4 mb-0" }, "Parabéns!"),
    /*#__PURE__*/ _createElementVNode("p", { class: "text-4" }, "Sua campanha já está ativa!")
], -1);
const _hoisted_12 = { class: "text-center" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", { class: "text-4" }, "Seja o primeiro a contribuir para a sua campanha e aumente em 70% as chances de alcançar seu objetivo.", -1);
const _hoisted_14 = ["href"];
const _hoisted_15 = { class: "text-center" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("p", { class: "text-4" }, "Divulgue o link abaixo para seus amigos e familiares e multiplique o alcance de sua campanha.", -1);
const _hoisted_17 = { class: "input-group my-3" };
const _hoisted_18 = ["value"];
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-copy" }, null, -1);
const _hoisted_20 = [
    _hoisted_19
];
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("div", {
    class: "btn btn-sm text-success shadow-none hide",
    id: "shareLinkCopied2"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-thumbs-up text-3" })
], -1);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("div", {
    class: "text-success hide text-center",
    id: "shareLinkCopied"
}, " Copiado! ", -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("p", { class: "text-4" }, "Ou compartilhe agora nas suas redes sociais clicando nos ícones abaixo!", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SocialShare = _resolveComponent("SocialShare");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    (_ctx.inicializando)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(" Carregando... ")
                        ]))
                        : _createCommentVNode("", true),
                    (!_ctx.inicializando)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("a", {
                                href: _ctx.campanha?.url,
                                class: "close"
                            }, _hoisted_10, 8, _hoisted_8),
                            _hoisted_11,
                            _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("a", {
                                    href: _ctx.campanha?.url + '/doar',
                                    class: "btn btn-primary text-3 mb-3",
                                    style: { "border-radius": "24px" }
                                }, "Doar para a minha campanha", 8, _hoisted_14)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("input", {
                                        type: "text",
                                        class: "form-control text-dark",
                                        readonly: "",
                                        value: _ctx.campanha?.url_encurtada_alt,
                                        id: "shareLink"
                                    }, null, 8, _hoisted_18),
                                    _createElementVNode("div", {
                                        class: "input-group-prepend btn btn-primary text-5 shadow-none",
                                        title: "Copiar",
                                        style: { "border-radius": "0px 4px 4px 0px" },
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.copiarParaAreaDeTransferencia('shareLink', 'shareLinkCopied')))
                                    }, _hoisted_20),
                                    _hoisted_21
                                ]),
                                _hoisted_22,
                                _hoisted_23,
                                (_ctx.campanha?.url)
                                    ? (_openBlock(), _createBlock(_component_SocialShare, {
                                        key: 0,
                                        url: _ctx.campanha?.url,
                                        text: 'Ajude a campanha ' + _ctx.campanha?.titulo + '. É só clicar neste link e contribuir: ' + _ctx.campanha?.url_encurtada
                                    }, null, 8, ["url", "text"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
